import { createFileRoute } from '@tanstack/react-router';
import { RegisterWorkPage } from '@/components/app/RegisterWorkPage';

export const Route = createFileRoute('/app/works/register')({
  component: RegisterWorkPage,
});
